(() => {
  var _addEventListener = Element.prototype.addEventListener;
  Element.prototype.addEventListener = function (type, listener, options) {
    _addEventListener.call(this, type, listener, options);
    this.listeners = this.listeners || {};
    this.listeners[type] = [
      ...(this.listeners[type] || []).filter(f => f !== listener),
      listener
    ];
  };

  var _removeEventListener = Element.prototype.removeEventListener;
  Element.prototype.removeEventListener = function (type, listener, options) {
    _removeEventListener.call(this, type, listener, options);
    (this.listeners || {})[type] = ((this.listeners || {})[type] || []).filter(f => f !== listener);
  };
})();